import React, {useMemo, useState} from "react";
import {Tooltip} from "antd";
import SettlementModal from "./SettlementModal";
import {AccountModel} from "../../../Domain/AccountDomain";
import {AxiosError} from "axios";
import moment from 'moment';
import lodash, {get} from 'lodash';
import {useHistory} from "react-router-dom";
import {NotificationCommon} from "../../../Component/Notification";
import {LinkDropdown} from "./LinkDropdown";
import localStore from "../../../Util/LocalStore";
import AccountApi from "../../../Api/AccountApi";
import {ACCOUNT_PERMISSIONS, PERMISSIONS} from "../../../Util/Constants";
import SecurityService from "../../../Util/SecurityService";

interface currencyProps {
    code: string
}

interface bankProps {
    code: string,
    name: string
}

interface ItemProps {
    index?: string | number,
    status?: string,
    code: string | any,
    currency: currencyProps,
    name: string,
    showAccount: (code: any) => void,
    type: string,
    accountHolder?: string,
    bank?: bankProps,
    accountNumber?: string,
    description?: string,
    note?: string,
    lastSettlementAt?: string,
    lastSettlementBy?: string
    showModalClone: () => void
    handleCheckingSettlementPermission:(accountCode:string,permission:string,cb:() => void|any)=> void;
}

const Item: React.FC<ItemProps> = (props: ItemProps) => {
    const {
        status,
        currency,
        name,
        code,
        showAccount,
        type,
        accountHolder,
        bank,
        accountNumber,
        description,
        lastSettlementAt,
        lastSettlementBy,
        handleCheckingSettlementPermission,
    } = props;

    const account: any = useMemo(() => {
        const p: any = {...props}
        delete p.showAccount

        return p
    }, [props])

    const [isShowSettlementModal, setIsShowSettlementModal] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState({...AccountModel});
    const settlementDuration = lodash.get(localStore.getJson('tenant'),'config.settlementDuration')
    const timeToShowAlert =  moment().subtract(moment.duration(settlementDuration)).subtract(1,'days') > moment(lastSettlementAt)
    const history = useHistory();

    const showSettlementModal = (account: any) => {
        setIsShowSettlementModal(true);
        setSelectedAccount(account);
    }

    const handleSettlementModalVisible = (visible: boolean) => {
        setIsShowSettlementModal(visible);
    }

    const handleSettlementSuccess = () => {
        NotificationCommon.success({
            message: "Chốt sổ thành công"
        });

        setIsShowSettlementModal(false);

        setTimeout(() => {
            window.location.reload();
        }, 500);
    }

    const handleSettlementFail = (error: AxiosError) => {
        if (get(error.response, 'status') === 400) {
            if (get(error.response, 'data.title') === 'voucher_status_ineligible') {
                NotificationCommon.error({
                    message: `${get(error.response, 'data.receiptVoucher')} phiếu thu, ${get(error.response, 'data.paymentVoucher')} phiếu chi cần phải được xác nhận hoặc huỷ hết trước khi chốt sổ`
                })
            }
            else if (get(error.response, 'data.title') === 'timestamp_invalid') {
                NotificationCommon.error({
                    message: 'Thời gian chốt không hợp lệ'
                })
            }
            else if (get(error.response, 'data.title') === 'settlement_at_ineligible') {
                NotificationCommon.error({
                    message: `Thời gian chốt sổ cần lớn hơn ${moment(lastSettlementAt).format("DD/MM/YYYY HH:mm")}`
                })
            }
            else {
                NotificationCommon.error({
                    message: error.message
                })
            }
        }
        else {
            NotificationCommon.error({
                message: error.message
            })
        }
    }

    const handleRouteToAccountDetail = () => {
        AccountApi.findByCode(code).then((response)=> {
            if(response) history.push(`/accounts/${code}`)
        }).catch((err)=> {
            if(err && err.response) {
                if(lodash.get(err.response.data,'status') === 403) {
                    NotificationCommon.error({
                        message:'Bạn không có quyền thực hiện thao tác này'
                    })
                }
            }
        })
    }
    // console.log(moment().subtract(moment.duration(settlementDuration)).format('DD/MM/YYYY HH:mm'))
    // console.log(moment().subtract(moment.duration(settlementDuration).asMilliseconds(),'milliseconds').format('DD/MM/YYYY HH:mm'))

    return (
        <div className={"account-item rounded mg-bt-12 bg-white"}>
            <div className={'head'}>
                <div className={(status === "ACTIVE" ? "icon-active" : "icon-inactive") + " self-center"}/>
                <div className={"account-item__name mg-l-8 overflow-hidden"} style={{width: "100%"}} onClick={handleRouteToAccountDetail}>
                    <Tooltip title={code}>
                        <div className={"font-size-14 bold text-maxW-250"}>
                            <span className={'link-span'}>{code}</span>
                        </div>
                    </Tooltip>
                    <span className={'mg-l-4'}><i className="fa-solid fa-pipe"/></span>
                    <Tooltip title={name}>
                        <div className={"font-size-14 bold text-maxW-250 mg-l-4"}>
                            <span className={'link-span'}>{name}</span>
                        </div>
                    </Tooltip>
                </div>
                <LinkDropdown account={account}/>
            </div>
            <div className={'body'}>
                {type === "BANK" && <div className={"account-item__bank_info"}>
                    <div className={"row"}>
                        <span className={'label'}>Ngân hàng:</span>
                        <Tooltip placement="topLeft" title={bank?.name}>
                            <div className={'bold text-maxW-300'}>{bank?.name}</div>
                        </Tooltip>
                    </div>
                    <div className={"row"}>
                        <span className={'label'}>Số tài khoản:</span>
                        <Tooltip placement="topLeft" title={accountNumber}>
                            <div className={'bold text-maxW-300'}>{accountNumber}</div>
                        </Tooltip>
                    </div>
                    <div className={"row"}>
                        <span className={'label'}>Chủ tài khoản:</span>
                        <Tooltip placement="topLeft" title={accountHolder}>
                            <div className={'bold text-maxW-300'}>{accountHolder}</div>
                        </Tooltip>
                    </div>
                </div>
                }
            </div>
            <div className="account-item__last_settlement">
                Chốt lần cuối lúc {moment(lastSettlementAt).format("DD/MM/YYYY HH:mm")} bởi {lastSettlementBy}
            </div>
            <div className={"bottom"}>
                <div className={"px-10 account-item__bottom__currency"}>
                    {currency.code}
                </div>
                <div className={'account-item__bottom__actions pd-bt-4'}>
                    <span onClick={() => handleCheckingSettlementPermission(code,ACCOUNT_PERMISSIONS.ACCOUNT_SETTLEMENT,() => showSettlementModal(props))} className={'font-size-12 pointer mg-r-12 '} style={{ color: '#27ae61' }}>
                        <i className="fa-regular fa-pen-to-square pd-r-4 "/>Chốt Sổ
                    </span>
                    <span  onClick={() => handleCheckingSettlementPermission(code,ACCOUNT_PERMISSIONS.ACCOUNT_VIEW,()=> showAccount(code))} className={'font-size-12 pointer'} style={{ color: '#27ae61' }} >
                        <i className="fa-regular fa-circle-info pd-r-4"/>Thông Tin Quỹ
                    </span>

                    {SecurityService.can(PERMISSIONS.ACCOUNT_CREATE) && (
                        <Tooltip className={'pointer'} title={'Nhân bản quỹ'} placement="topRight" arrowPointAtCenter>
                            <span className="mg-l-8" style={{ color: '#27ae61' }} onClick={() => {
                                props.showModalClone()
                            }}>
                                <i className="fa-light fa-clone"/>
                            </span>
                        </Tooltip>
                    )}

                    {description && description?.length > 0 &&
                        <Tooltip title={description} arrowPointAtCenter placement="topRight">
                            <span className="mg-l-8 px-4 text-secondary-color-2 pointer">
                                <i className="fa-solid fa-note-sticky"/>
                            </span>
                        </Tooltip>}
                    {timeToShowAlert && <Tooltip
                        title={<div> Hệ thống sẽ tự động chốt sổ vào thời điểm <span className={'bold'}>{moment().subtract(moment.duration(settlementDuration)).format('DD/MM/YYYY')}!</span></div>}
                        placement="topRight" className={'account-item__description mg-l-4'}
                        arrowPointAtCenter
                    >
                        <i className="fa-regular fa-triangle-exclamation text-yellow pointer"/>
                    </Tooltip>}
                </div>
            </div>

            {isShowSettlementModal && (
                <SettlementModal
                    onVisibleChange={handleSettlementModalVisible}
                    onSuccess={handleSettlementSuccess}
                    onFail={handleSettlementFail}
                    account={selectedAccount}
                />
            )}
        </div>
    );
}

export default Item;
